import api from "../axiosIntercepture";

export const userLogin = async (userData) => {
    try {
        const response = await api.post("auth/login", userData);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message || "Login failed";
    }
}

export const userLogout = async (token) => {
    try {
        await api.post("auth/logout", { token });
    } catch (err) {
        // Continue with local logout even if server logout fails
        console.error("Logout API error:", err);
        // Don't throw error to ensure UI can complete logout process
    }
}

export const updatePassword = async ({ currentPassword, newPassword, confirmPassword }) => {
    try {
        const response = await api.post("auth/update-password", {
            currentPassword,
            newPassword,
            confirmPassword,
        });
        return response.data?.message || "Password updated";
    } catch (err) {
        throw err?.response?.data?.message || "Failed to update password";
    }
}

export const forgotPassword = async (email) => {
    try {
        const response = await api.post("auth/forgot-password", { email });
        return response.data?.message || "Password reset link sent.";
    } catch (err) {
        throw err?.response?.data?.message || "Failed to send password reset link";
    }
}

export const selfSignUp = async (data) => {
    try {
        const response = await api.post("auth/self-signup", { ...data });
        return response.data?.message;
    } catch (err) {
        throw err?.response?.data?.message || "Registration failed";
    }
}

export const isTokenValid = async () => {
    try {
        const response = await api.post("auth/validate-token");
        return response.data?.data;
    } catch (err) {
        // Make sure we never throw undefined
        if (!err?.response?.data?.error) {
            throw new Error("Token validation failed");
        }
        throw err?.response?.data?.error;
    }
}


export const setDefaultFacility = async (defaultFacility) => {
    try {
    
        const sendObject = {
            facilityId : defaultFacility?.facilityId,
            roleId :defaultFacility?.roleId
        }
        const response = await api.post("auth/setdefault-facility", sendObject);
        return response.data?.data;
        
    } catch (err) {
        throw err?.response?.data?.message || "Default Facility Selection Failed";
    }
}